import { z } from "zod";

export const SENKRON_YIGIN_SINIRI = 200;

/**
 * CEVRIMDISI SENKRON SOZLESMESI
 *
 * Ogrenci internetsizken veri girer; giris telefonda bekler ve baglanti
 * gelince gonderilir (sistem tanitimi §05, §18).
 *
 * `istemciKayitId` bu isin belkemigidir: istemcide uretilir, ayni mutasyon
 * iki kez gonderilse bile sunucu ikinci kez YENI KAYIT ACMAZ. Bu olmadan
 * zayif baglantida cift kayit kacinilmazdir — istek gider, yanit donmez,
 * istemci tekrar dener.
 */

/** Cevrimdisi kuyruga girebilen islem tipleri. Liste BILINCLI olarak dardir. */
export const KUYRUK_ISLEMLERI = [
  "gorev.sonuc.gir", // dogru / yanlis / bos
  "gorev.mazeret.bildir", // yapamadi, neden secildi
  "calisma.sayac.kaydet", // calisma suresi
  "konu.durum.degistir",
] as const;

export const kuyrukIslemiSemasi = z.enum(KUYRUK_ISLEMLERI);
export type KuyrukIslemi = z.infer<typeof kuyrukIslemiSemasi>;

/** Aynı kaynağı değiştiren işlemler aynı sırayı paylaşır; yetki doğrulaması değildir. */
export function senkronKaynakAnahtari(islem: string, govde: Record<string, unknown>): string {
  const metin = (alan: string): string => {
    const deger = govde[alan];
    return typeof deger === "string" && deger.length > 0 ? deger : "?";
  };
  switch (islem) {
    case "gorev.sonuc.gir":
    case "gorev.mazeret.bildir":
    case "calisma.sayac.kaydet":
      return `gorev:${metin("gorevId")}`;
    case "konu.durum.degistir":
      return `konu:${metin("ogrenciId")}:${metin("konuId")}`;
    default:
      return `bilinmeyen:${islem}`;
  }
}

export const KUYRUK_DURUMLARI = ["bekliyor", "gonderiliyor", "gonderildi", "hatali"] as const;
export const kuyrukDurumuSemasi = z.enum(KUYRUK_DURUMLARI);
export type KuyrukDurumu = z.infer<typeof kuyrukDurumuSemasi>;

export const kuyrukKaydiSemasi = z.object({
  // F-STV-11 — yerel kayıt başka oturumun çereziyle gönderilemez.
  sahipKullaniciId: z.string().min(1),
  gonderimPartisiId: z.string().optional(),
  /** Sahip başına kalıcı eklenme sırası; eski kayıtlarda bulunmayabilir. */
  siraNo: z.number().int().positive().safe().optional(),
  /** Istemcide uretilir — sunucu tarafinda tekillik anahtaridir */
  istemciKayitId: z.string().min(8),
  islem: kuyrukIslemiSemasi,
  govde: z.record(z.unknown()),
  /** Islemin telefonda YAPILDIGI an — sunucuya ulastigi an degil */
  yapildiAt: z.string().datetime(),
  durum: kuyrukDurumuSemasi,
  denemeSayisi: z.number().int().min(0),
  sonHata: z.string().nullable(),
});

export type KuyrukKaydi = z.infer<typeof kuyrukKaydiSemasi>;

export const senkronIstegiSemasi = z.object({
  // F-STV-11 — eski PWA istekleri geçerlidir; yeni istemci sahibi parti düzeyinde gönderir.
  sahipKullaniciId: z.string().min(1).optional(),
  kayitlar: z.array(
    kuyrukKaydiSemasi.omit({
      durum: true,
      denemeSayisi: true,
      sonHata: true,
      sahipKullaniciId: true,
      gonderimPartisiId: true,
      siraNo: true,
    }),
  ),
});

export const senkronSonucuSemasi = z.object({
  kabul: z.array(z.string()), // istemciKayitId listesi
  reddedilen: z.array(
    z.object({
      istemciKayitId: z.string(),
      kod: z.string(),
      mesaj: z.string(),
      /** true ise istemci bir daha denemez — kalici red */
      kalici: z.boolean(),
    }),
  ),
});

export type SenkronSonucu = z.infer<typeof senkronSonucuSemasi>;
